import dayjs from 'dayjs';
//stage names
export const IDFC_AADHAAR = "idfc_aadhaar";
export const IDFC_CONSENT = "idfc_consent";
export const IDFC_PAN = "idfc_pan";


export const OTP_MISMATCH = "OTP_MISMATCH";
export const DISPLAY_ERROR_PAGE = "DISPLAY_ERROR_PAGE";
export const DISPLAY_ERROR = "DISPLAY_ERROR";
export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const LOGIN_REQUIRED = "LOGIN_REQUIRED";
export const INTERNAL_ERROR = "INTERNAL_ERROR";
export const REFRESH_ERROR = "REFRESH_ERROR";
export const BAD_REQUEST = "BAD_REQUEST";
export const ERROR_NO_ACTION = "ERROR_NO_ACTION";

//responsestatus
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const WARNING = "WARNING"

//user states
export const ACTIVE = "ACTIVE";
export const SUSPENDED = "SUSPENDED";

export const EPM = "EPM";
export const PM = "PM";

//context values
export const TRANSACTION = "transaction";
export const ONBOARDING = "onboarding";
export const INSURANCE = "insurance";
export const LANDING = "landing";
export const LEDGER = "ledger";

//Travel Loan Constants
export const WEBVIEW = 'WEBVIEW';
export const BROWSER = 'BROWSER';
export const HOME_PAGE = 'HOME_PAGE';
export const CF_NEW = 'CF_NEW';
export const INSTANT_CASH = 'INSTANT_CASH';
//query params
export const CONTEXT = "context";
export const OTU_TOKEN = "otuToken";

//Lenders
export const KISSHT = "kissht";
export const ZEST = "zest";
export const IDFC = "idfc";
export const CF = "cf";

//for init page params
export const REFRESH = "refresh";
export const RETURN_URL = "returnUrl";

export const timerDuration = 30;

//strings
export const MOBILE = "mobile";
export const TRAVEL_CREDIT_LINE_CTA = "tcl"
export const ALREADY_VERIFIED = "alreadyVerified";
export const LINKED = "linked";
export const ANDROID = "android";
export const IOS = "ios";
export const UNKNOWN = "unknown";
export const DEEPLINK = "deeplink";
export const DEEPLINK_PARAM_ORDER_ID = "dp_orderId";
export const FOREX_COMMON_ROUTE = "common"

export const INR_DEEPLINKS = ["inr-card","load-money","transactions-settings", "withdraw-money", "card-delivery-tracking"]
export const BMF_DEEPLINKS = ["bmf-card", "bmf-currencies", "bmf-order-status","reload_track_order","reload_upload_docs","reload_load_currency","bmf_traveller_details", "bmf_load_currency", "bmf_onboarding_landing", "reload_dashboard", "bmf_order_submitted"];
export const DEEPLINKS_MAP = {
    INR_CARD:"inr-card",
    LOAD_MONEY:"load-money",
    TRANSACTIONS_SETTINGS:"transactions-settings",
    WITHDRAW_MONEY: "withdraw-money",
    CARD_DELIVERY_TRACKING: "card-delivery-tracking",
    BMF_CURRENCIES: "bmf-currencies",
    BMF_CARD: "bmf-card",
    BMF_ORDER_STATUS:"bmf-order-status",
    RELOAD_TRACK_ORDER: 'reload_track_order',
    RELOAD_UPLOAD_DOCS: 'reload_upload_docs',
    RELOAD_LOAD_CURRENCY: 'reload_load_currency',
    BMF_TRAVELLER_DETAILS:"bmf_traveller_details",
    BMF_LOAD_CURRENCY:"bmf_load_currency",
    BMF_ONBOARDING_LANDING: "bmf_onboarding_landing",
    RELOAD_DASHBOARD:"reload_dashboard",
    BMF_ORDER_SUBMITTED:"bmf_order_submitted"
}

export const EXISTING_DEEPLINKS = Object.values(DEEPLINKS_MAP)
export const PROTECTED_DEEPLINKS_MAP = {
    "inr-card":true,
    "load-money":true,
    "transactions-settings":true,
    "withdraw-money": true,
    "card-delivery-tracking":true,
    "bmf-card":true,
    "bmf-currencies":true,
    "bmf-order-status":true,
    'reload_track_order':true,
    'reload_upload_docs':true,
    'reload_load_currency':true,
    "bmf_traveller_details":true,
    "bmf_load_currency":true,
    "bmf_onboarding_landing": true,
    "reload_dashboard":true,
    "bmf_order_submitted":true
}

//deep links
export const DEEP_LINK_TRAVEL_LOAN_TOP = "https://applinks.makemytrip.com/iCixTABdHsb";
export const DEEP_LINK_TRAVEL_LOAN_BOTTOM = "https://applinks.makemytrip.com/ifdOOkHdHsb";
export const DEEP_LINK_TRAVEL_CREDIT = "https://applinks.makemytrip.com/kjzOL8j6Isb";
export const MAKEMYTRIP_LINK = "https://www.makemytrip.com";

//to redirect to thank you page in insurance, this has to present in init otu url as queryparam
export const BOOKING_REDIRECT = "bookingRedirect";
export const VERTICAL_TXN_ID = "vertical_txn_id"
export const INSURANCE_PRODUCT = "insuranceProduct";
export const INSURANCE_OFFERINGS = "insurance-offerings";
export const INS_NEW_FLOW = "ins_new_flow";
export const INS_NEW_REDIRECT_URL = "ins_new_redirect_url";
export const DOB_LENGTH = 10;
export const MMT_FOREX_FLOW = 'mmt_forex';
export const MMT_FOREX_COOKIE = 'mmt_forex';
export const MMT_FOREX_URL = 'https://www.makemytrip.com/forex';

// common url for logo assets

export const TRIPMONEY_LOGO_URL = "data:image/png;base64,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"
export const TRIPMONEY_GI_CARD_IMAGE = "https://tripmoneycmsimgak.mmtcdn.com/img/gi_Card_Logo_New_cb92777c81.png";
export const TRIPMONEY_MMT_CARD_IMAGE = "https://tripmoneycmsimgak.mmtcdn.com/img/virtual_Card_Bg_New_c320caa54b.png";


//PDT 
export const INS_UI_EVENTS = "INS_UI_EVENT"
export const VIEW_PLANS_CTA_CLICK  = "VIEW_PLANS_CTA_CLICK"
export const PLAN_DETAILS_CTA_CLICK = "PLAN_DETAILS_CTA_CLICK"
export const BUY_NOW_CTA_CLICK = "BUY_NOW_CTA_CLICK"
export const PLAN_DETAILS_BUY_CTA_CLICK = "PLAN_DETAILS_BUY_CTA_CLICK"

//For forex
export const FOREX = "forex";
export const LOGIN_SESSION_STORAGE_KEY = "isAppLoggedIn";

export const getFormattedAmount = (amount, noDecimals = false) => {
    if (amount == "" || !amount) {
        amount = "0";
    }
    let val = Number(amount).toString();
    val = val.substring(0, val.length - 2) + (!noDecimals ? "." + val.substring(val.length - 2) : "");

    return `Rs. ${new Intl.NumberFormat('en-IN', { maximumFractionDigits: (noDecimals ? 0 : 2), minimumFractionDigits: 0 }).format(Number(val))}`;
}


export const formatDate = (date) => {
    if (dayjs(date).isValid()) {
        return dayjs(date).format('DD-MMM-YYYY h:mmA')
    } else {
        return date
    }
}

// Landing CDN images
export const CUSTOMER_IMG = "https://tripmoneycmsimgak.mmtcdn.com/img/custmer_Img_f2063531cc.png"
export const CUSTOMER_IMG2 = "https://tripmoneycmsimgak.mmtcdn.com/img/testimonial1_71c4131518.jpg"
export const CUSTOMER_IMG3 = "https://tripmoneycmsimgak.mmtcdn.com/img/test3_img_9557634af6.jpg"
export const TRAVEL_LOAN = "https://tripmoneycmsimgak.mmtcdn.com/img/travel_Loan_cfec85b0ca.png"
export const IDFC_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/idfc_06929038af.png"
export const AXIO_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/axio_b3b6e63044.png"
export const KISSHT_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/kissht_3363323d1e.png"
export const HDFC_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/hdfc_3cc507194b.png"
export const ZEST_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/zest_84ba33c87c.png"
export const COVID_INSURANCE = "https://tripmoneycmsimgak.mmtcdn.com/img/covid_Insurance_77a1e3379f.png"
export const TRIPMONEY_WHITELOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/tm_Logo_white_7b27500a79.png"
export const WATERBACK = "https://tripmoneycmsimgak.mmtcdn.com/img/water_Back_1c1993bc79.png"
export const FINANCIAL_OFFERINGS = "https://tripmoneycmsimgak.mmtcdn.com/img/financial_Offerings_bd91e27c79.png"
export const MMT_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/Group_5260_1_fa6d286bf6.png"
export const GOIBIBO_LOGO = "https://tripmoneycmsimgak.mmtcdn.com/img/Group_2_ce7a87d5c1.png"
export const API_TIMEOUT = 30000;

export const REF_ID = "refID";
export const KEY = "key";

// insurance types
export const STANDALONE = 'standalone';

//insurance providers
export const DIGIT = "DIGIT";

//insurance products
export const DIGIT_COVID = "covid19";
export const DIGIT_HOSPICASH = "digit_hospicash";
export const ADITYA_BIRLA_HOSPICASH = "aditya_birla_hospicash";
export const RELIANCE_COVID_HOSPICASH = "reliance_covid_hospicash";

export const FPO = "fpo";

export const things_to_know_idfc = "things_to_know_idfc";
export const things_to_know_zest = "things_to_know_zest";
export const things_to_know_cf = "things_to_know_cf";
export const things_to_know_kissht = "things_to_know_kissht";

export const ledger_charges_and_fees = "ledger_charges_and_fees";

export const eu_region_error = 'eu_region_error';

export const MakeMyTrip = "mmt";
export const GoIbibo = "gi";
export const TripMoney = "tm";


//for wishfin
export const USER_ID = "userId";
export const APPLICATION_ID = "applicationId";
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const BANK_NAME = "bankName";


export const NAY_LENDER = "NAY";
export const LOGIN_FROM_LANDING = "login-landing";

//for wishfin
export const SBI = "SBI";
export const SCB = "SCB";

//for closing webview when user comes back from cf in b/w
export const ACTION = "action";
export const CLOSE = "close";
export const APP_VERSION  = "app_version"
//for new tripmoney mobile only landing page
export const ACCOUNT = "ACCOUNT";
export const LEFT_OFF = "LEFT_OFF";
export const NAVIGATION = "NAVIGATION";
export const TRENDING = "TRENDING";
export const HEAD_CAROUSEL = "HEAD_CAROUSEL";

//for tm suspended
export const TM_SUSPENDED = "TM_SUSPENDED";

//LENDER STEPS
export const LEDGER_ = "LEDGER"
export const REDIRECT_ = "REDIRECT"
export const REJECTED_  = "REJECTED"
export const ERROR_PAGE_ = "ERROR_PAGE"
export const WAITLIST_ = "WAITLIST"
export const SUSPENDED_ = "SUSPENDED"
export const PENDING = "PENDING"
export const APPROVED = "APPROVED"
export const DISBURSED = "DISBURSED"

//for pdt logging
export const EVENT_IDENTIFIER = "card_suggestion_id";
export const CARD_CLICKED = "card_clicked";
export const TCL_OTP_VERIFIED = "tcl_otp_verified";

// for CMS
export const COMPONENT_KEY = '__component';
export const HP_TOP_PROMOTIONS_SECTION = 'homepage.top-promotions-section'
export const HP_PRODUCTS_SECTION = 'homepage.product-section';
export const HP_CUSTOMER_SECTION = 'homepage.customer-section';
export const HP_REVIEWS_SECTION = 'homepage.review-section';
export const HP_PARTNERS_SECTION = 'elements.image';
export const HEADER_LINK = 'repeatable.r-link';
export const HEADER_ELEMENTS_LINK = 'analytics.cta';

export const HOMEPAGE_KEY = 'tm-homepage';
export const FOOTER_KEY = 'tm-header-footer';
export const TRAVEL_LOAN_PAGE_KEY = 'tm-travel-loan-page';
export const CREDIT_CARD_PAGE_KEY = 'tm-credit-card-page';
export const ABOUT_US_PAGE_KEY = 'tm-about-us-page';
export const PRIVACY_POLICY_PAGE_KEY = 'tm-privacy-policy-page';
export const USER_AGREEMENT_PAGE_KEY = 'tm-user-agreement-page';
export const ZOPPER = "zopper";
export const FEEDBACK_REVIEWS = 'feedback_reviews';

// BMF
export const BMF_HOMEPAGE_KEY = 'bmf-homepage';
export const BMF_OFFER_DETAILS = 'bmf_homepage_offers_details';
export const BMF_TESTIMONIALS_DETAILS = 'bmf_testimonials_details';
export const BMF_CAROUSEL_DETAILS = 'bmf_carousel_details';

export const POST_SALES = "postSales";
export const POST_SALES_ERROR_MESSAGE = "post_sales_error_message";
export const POST_SALES_DATE_PASSED_ERROR = "post_sales_date_passed_error";
export const POST_SALES_INSURANCE_DETAILS = "post_sales_insurance_details";
export const POST_SALES_INSURANCE_DETAILS_PREMIUM = "post_sales_insurance_details_premium";
export const BOOKING_ID = "bookingId";
export const BOOKING_ID_CAPS = "bookingID";
export const PID = "pId";
export const BID = "bId";
export const ORDER_ID = "orderId";


//lobs
export const FLIGHT = "flight";
export const HOTEL = "hotel";
export const HOLIDAY = "holiday";

// standalone insurance
export const SELECT = "select";
export const fields = Object.freeze({
    name: "Full Name",
    email: "Email Address",
    mobile: "Mobile No.",
    passportNumber: "Passport Number",
    gender: "Gender",
    dob: "Date of Birth",
    nomineeName: "Nominee Name",
    nomineeRelationship: "Nominee Relationship",
    nationality: "Nationality",
    bloodRelation: "Blood Relation",
    countryCode: "Country Code"
});

//banner types

export const BMFHANDLING = "BmfHandling";
export const OFFERINGHANDLING= "OfferingSilder";


export const fieldsMap = Object.freeze({
    "Full Name": "name",
    "Date of Birth": "dob",
    "Email Address": "email",
    "Mobile No.": "mobile",
    "Passport Number": "passportNumber",
    "Nominee Name": "nomineeName",
    "Nominee Relationship": "nomineeRelationship",
    "Nationality": "nationality",
    "Gender": "gender",
    "Blood Relation": "bloodRelation",
    "Country Code": "countryCode"
});

export const fieldTypes = Object.freeze({
    "Full Name": "text",
    "Date of Birth": "text-date",
    "Email Address": "text",
    "Mobile No.": "number",
    "Passport Number": "text",
    "Gender": "radio",
    "Nominee Name": "text",
    "Nominee Relationship": "text",
    "Nationality": "text",
    "Blood Relation": "checkbox"
});

// payment modes

export const NEFT = "NEFT";
export const PGLOAD = "PGLOAD";
export const inputClassForFields = Object.freeze({
    passportNumber: "cap-text"
});

export const STANDALONE_TOP_COUNTRIES = 'standalone_top_countries';

export const VIEW_POLICY = 'view-policy';
export const BMF_UI_CONFIG = 'bmf_ui_config';

//bmf states
export const ADD_PRODUCTS = 'add_products';
export const UPDATE_TRIP_PURPOSE = 'update_trip_purpose';
export const UPLOAD_DOCUMENTS = 'upload_documents';
export const UPDATE_TRAVELLER_DETAILS = "update_traveller_details";
export const UPDATE_TRIP_DETAILS = "update_trip_details";
export const UPDATE_TRIP_DURATION = "update_trip_duration";
export const DOCUMENT_CONCENT = "document_consent";
export const BMF_UPDATE_ADDRESS = "bmf_update_address";
export const CONTINUE_FORM = "continue-form";
export const BMF_CONFIRM_ORDER_DETAILS = "confirm_order_details"
export const BMF_ORDER_COMPLETE = "order_complete"
export const BMF_DOCUMENT_UPLOADS = "upload_documents"
export const BMF_ORDER_CONFIRMED = "order_confirmed"
export const BMF_PAYMENT_BEING_CONFIRMED = "payment_being_confirmed"
export const BMF_PAYMENT_CONFIRMED = "payment_confirmed"
export const BMF_PAYMENT_FAILED = "payment_failed"
export const BMF_PAYMENT_NOT_COMPLETED = "payment_not_completed"
export const BMF_PAYMENT_START = "start_payment"
export const ADD_MORE_PRODUCTS = "add_more_products"

export const OTHER_CHARGES_MAPPING = {
    "PAYMENT_CONVENIENCE_CHARGE": "Payment Convenience Charge",
    "DELIVERY_CHARGE": "Service Charge"
}

export const OTP_RETRY = "OTP_RETRY"
export const SESSION_EXPIRED = "sessionExpired";
export const FAILED = "FAILED";

export const EXIT = "EXIT";

export const defaultCountry = {
    name: "India",
    nameCode: "in",
    phoneCode: "91"
};

export const errorPageName = Object.freeze({
    DISPLAY_ERROR_PAGE: 'displayErrorPage',
    INTERNAL_SERVER_ERROR: 'internalServerErrorPage'
})

export const defaultDisplayErrorPage = Object.freeze({
    TITLE: "Oh No!",
    ERROR_DESCRIPTION: "Something went wrong.\n Please try again later.",
});

export const defaultInternalServerErrorPage = Object.freeze({
    TITLE: "Server Down",
    ERROR_DESCRIPTION:
        "It looks like our server took too long.\n Please try again after some time.",
});



export const UNPROTECTED_API_FOREX_ROUTES = [
    "/card-management/api/v1/forex-rate",
    "/krysalisConfig"
]

export const NEW_INSURANCE_DOMAIN = "tripmoney.makemytrip.com";
export const INS_MMT_SUBDOMAIN = "insurance.makemytrip.com"
export const INS_GI_SUBDOMAIN = "insurance.goibibo.com"
export const BACKOFFICE_ADMIN_SUBDOMAIN_DEPRECATED = "tripmoney-insurance.mmt.com"
export const BACKOFFICE_ADMIN_SUBDOMAIN = "tripmoney-insurance.mmt.live"
export const RBI_GUIDELINES = "Due to RBI-KYC guidelines, you can spend a maximum of Rs.60,000/- per transaction."

export const SOURCE_PLATFORM = {
    TRIPMONEY: 'tripmoney',
    MAKEMYTRIP: 'makemytrip',
    GOIBIBO: 'goibibo',
    LOCALHOST: 'localhost',
};

export const MMT_SUB_DOMAIN = ".makemytrip.com";

export const GI_SUB_DOMAIN = ".goibibo.com";

export const COOKIES = {
    MMT_AUTH_KEY: 'mmt-auth',
    TM_AUTH_KEY: 'x-tm-auth',
    MMT_LOGIN_REDIRECT_KEY: 'loginActionDetails',
    TM_MMT_AUTH_KEY: 'tm-mmt-auth',
    GI_AUTH_KEY:'OAUTH-GOIBIBO',
    TM_GI_AUTH_KEY:'tm-gi-auth',
    MMT_DEVICE_ID: 'dvid',
    GI_DEVICE_ID: '__gi_vid',
};

export  const IS_INITOTU_SESSION_KEY = "is_initotu";
export const DEVICE_MODEL_TYPE  = {
    APP: 'App',
    WEB: 'Web',
}
